import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SpriteSvg from './SpriteSvg';

const publicPath = process.env.PUBLIC_URL || '';

class SvgIcon extends Component {
    static ARROW_DOWN = "ARROW_DOWN";
    static CLOSE = "CLOSE";
    static MAIN_TITLE = "MAIN_TITLE";
    static PROXY = "PROXY";

    render() {
        const {
            x,
            y,
            width,
            height,
            tagName,
            tagClassName,
            className,
            path,
            icon,
            fill,
            stroke,
            viewBox
        } = this.props;

        const imagePath = icon ? `${path}/${icon.toLowerCase()}.svg` : '';

        return (
            <SpriteSvg
                tagClassName={classNames('SvgIcon', tagClassName)}
                tagName={tagName}
                className={classNames('SvgIcon__svg', className)}
                srcClassName={className}
                src={imagePath}
                defaultIcon={null}
                viewBox={viewBox}
                svgProps={{ x, y, width, height, fill, stroke }}
            />
        );
    }
}

SvgIcon.defaultProps = {
    path: `${publicPath}/images/icons`,
    tagName: 'i',
    tagClassName: '',
    className: '',
    fill: '',
    stroke: '',
    icon: '',
    x: 0,
    y: 0,
};

SvgIcon.propTypes = {
    /**
     * Path to icons folder
     */
    path: PropTypes.string,
    /**
     * Wrapper tag
     */
    tagName: PropTypes.string,
    /**
     * Wrapper tag class name
     */
    tagClassName: PropTypes.string,
    /**
     * Svg tag class name
     */
    className: PropTypes.string,
    /**
     * Fill color
     */
    fill: PropTypes.string,
    /**
     * Icon name
     */
    icon: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    /**
     * Icon width in px
     */
    width: PropTypes.number,
    /**
     * Icon height in px
     */
    height: PropTypes.number,
    /**
     * Icon viewbox value
     */
    viewBox: PropTypes.string,
};

export default SvgIcon;
